<template>
    <form action="" method="POST" @submit.prevent="submit" novalidate autocomplete="off">
        <div class="col-2">
            <form-input-type-text
                name="first_name"
                :value="prefill.firstName"
                label="Vorname"
                :errors="errors.first_name"
                full-border
                required
            ></form-input-type-text>

            <form-input-type-text
                name="last_name"
                :value="prefill.lastName"
                label="Nachname"
                :errors="errors.last_name"
                full-border
                required
            ></form-input-type-text>
        </div>

        <div class="col-2">
            <form-input-type-email
                name="email"
                label="E-Mail"
                :value="prefill.email"
                :errors="errors.email"
                full-border
                required
            ></form-input-type-email>

            <form-input-type-phone-number
                name="phone_number"
                :value="prefill.phone"
                label="Telefonnummer"
                :errors="errors.phone_number"
                phoneCountry="de"
                full-border
                required
            ></form-input-type-phone-number>
        </div>

        <div class="col-2">
            <form-input-type-text
                name="insurance_id"
                label="Ihre Versicherungsnummer"
                :errors="errors.insurance_id"
                note="Die Versicherungsnummer finden Sie auf Ihrer Krankenversicherungskarte"
                full-border
                required
            ></form-input-type-text>

            <!-- <form-input-type-select
                v-if="insuranceCompanies != null"
                name="insurance_company_id"
                label="Ihre Krankenversicherung"
                :options="companyNames"
                :errors="errors.insurance_company_id"
                search-placeholder="Krankenkasse suchen"
                full-border
                required
            ></form-input-type-select> -->

            <div class="input-wrapper form-input-text input-has-full-border search-wrapper" @focusout="handleFocusOut">
                <label :class="{ 'float-label-active': isActive || searchValue, 'is-float-label': true }">Ihre Krankenversicherung<span>*</span></label>
                <span class="material-symbols-rounded">search</span>
                <input
                    class="full-border"
                    type="text"
                    placeholder="Krankenkasse suchen"
                    name="insurance_company"
                    id="insurance_company"
                    v-model="searchValue"
                    @click="toggleDropdown()"
                />

                <div v-if="insuranceCompanies && isDropdownActive" class="insurance-companies-dropdown">
                    <ul class="no-list-style">
                        <li v-for="company in companiesArray" :key="company.id">
                            <a href="#" :data-id="company.id" @click.prevent="selectCompany(company.name, company.id)">{{ company.name }}</a>
                        </li>

                        <li v-if="companiesArray.length === 0">
                            <span>Nichts gefunden</span>
                        </li>
                    </ul>
                </div>

                <form-input-error
                    v-if="errors && errors.insurance_company_id"
                    :error="errors.insurance_company_id[0]"
                ></form-input-error>
            </div>
        </div>

        <form-input-type-select
            name="document_type"
            label="Dokumenttyp"
            :options="[
                {value: 'rezept', label: 'Rezept'},
                {value: 'diagnosenachweis', label: 'Diagnosenachweis'},
            ]"
            :errors="errors.document_type"
            required
            full-border
        ></form-input-type-select>

        <form-input-type-text
            v-if="documentType === 'diagnosenachweis'"
            name="shipping_address"
            label="Ihre Adresse für den Versand des Freischaltcodes"
            :errors="errors.shipping_address"
            full-border
            required
        ></form-input-type-text>

        <div class="col-2">
            <!-- <form-input-type-select
                name="shop_support"
                label="Unterstützung durch Diabetes-Fachgeschäft"
                :options="[
                    {label: 'Keine Unterstützung', value: null},
                    {label: 'DIASHOP', value: 'Diashop'},
                ]"
                :errors="errors.shop_support"
                full-border
            ></form-input-type-select> -->

            <form-input-type-text
                name="referral"
                label="Empfehlungscode"
                :errors="errors.referral"
                :value="referralValue"
                full-border
            ></form-input-type-text>

            <form-input-type-select
                name="prescription_number"
                label="Ist es Ihr erstes Rezept / erster Diagnosenachweis?"
                :options="[
                    {value: 'true', label: 'Ja'},
                    {value: 'false', label: 'Nein'},
                ]"
                :errors="errors.prescription_number"
                required
                full-border
            ></form-input-type-select>
        </div>

        <form-input-upload-file
            name="confirmation_of_diagnosis"
            label="Rezept oder Diagnose&shy;nachweis hochladen"
            :allowed-files="['.pdf', '.jpg', '.png', '.jpeg']"
            :errors="errors.confirmation_of_diagnosis"
            :max-files-count="2"
        ></form-input-upload-file>

        <form-input-type-text-area
            name="message"
            label="Nachricht"
            :errors="errors.message"
            :maxlength="500"
            full-border
        ></form-input-type-text-area>

        <p class="form-mandatory-fields">* Felder mit Sternchen (*) sind Pflichtfelder.</p>

        <!-- <form-input-type-checkbox
            name="dmp"
            label='Ich bin Teil des DMP (Disease-Management-Programm) für Diabetes Typ 2'
            :errors="errors.dmp"
            required
        ></form-input-type-checkbox> -->

        <form-input-type-checkbox
            name="agreements"
            label='Ich bin damit einverstanden, dass die Vitadio das hochgeladene Dokument und die darin enthaltenen und eingegebenen persönlichen Daten an meine Krankenversicherung weiterleitet. Ich versichere, dass ich bei der angegebenen Krankenkassenversicherung versichert bin und die eingegebenen persönlichen Daten gültig sind. Ich habe die Informationen in der <a href="/datenschutzerklarung" target="_blank">Datenschutzerklärung</a> gelesen und verstanden und bin mit ihnen einverstanden.'
            :errors="errors.agreements"
            required
        ></form-input-type-checkbox>

        <v-button label="Freischaltcode anfordern" type="submit" size="lg" full-width></v-button>
    </form>
</template>

<script>
    export default {
        data() {
            // Předvyplnění z onboardingu. Data přicházejí ze sessionStorage,
            // ne z URL — stránka načítá Clarity i GA a jméno s e-mailem
            // a telefonem by skončily v nahrávkách relací a v access logu.
            const prefill = this.readPrefill()

            return {
                prefill,
                hasFiles: false,
                errors: {},
                insuranceCompanies: null,
                ga_client_id: null,
                gcl_id: null,
                searchValue: prefill.insuranceCompanyName || '',
                isActive: false,
                isDropdownVisible: false,
                insuranceCompanyId: prefill.insuranceCompanyId || '',
                documentType: null,
                referralValue: '',
            }
        },

        watch: {
            errors: {
                immediate: true,
                handler(errors) {
                    if (errors === null || errors === undefined || errors.length === 0) {
                        this.hasError = false
                    } else {
                        this.hasError = true
                    }
                }
            }
        },
        created() {
            this.initAttribution()
        },
        mounted() {
            this.fetchCompanies()

            $('#document_type').on('changed.bs.select', (e) => {
                this.documentType = e.target.value
            })
        },
        computed: {
            companiesArray() {
                let filteredCompanies = _.orderBy(this.insuranceCompanies, ['name'], ['asc'])

                if (this.searchValue != '' && this.searchValue) {
                    filteredCompanies = filteredCompanies.filter((item) => {
                        if(item.name.toLowerCase().includes(this.searchValue.toLowerCase())) {
                            return item
                        }
                    })
                }

                return filteredCompanies
            },

            isDropdownActive() {
                return this.isDropdownVisible && this.insuranceCompanies && this.insuranceCompanies.length > 0;
            }
        },
        methods: {
            readPrefill() {
                const empty = {
                    firstName: '', lastName: '', email: '', phone: '',
                    insuranceCompanyId: null, insuranceCompanyName: ''
                }

                try {
                    const raw = sessionStorage.getItem('vitadio.prescriptionPrefill')

                    return raw ? Object.assign(empty, JSON.parse(raw)) : empty
                } catch (e) {
                    return empty
                }
            },

            initAttribution() {
                let referral = null

                try {
                    const params = new URLSearchParams(window.location.search)
                    referral = params.get('referral') || sessionStorage.getItem('vitadio_referral')
                } catch (e) {}

                if (referral) {
                    this.referralValue = referral
                }
            },
            submit() {
                const formData = new FormData()
                const fileInput = document.getElementById('confirmation_of_diagnosis')
                let files = [...fileInput.files]

                let gaCookie = window.getCookie("_ga")
                let gclCookie = window.getCookie("_gcl_aw")

                if(gaCookie !== "" && gaCookie !== "undefined") {
                    this.ga_client_id = gaCookie
                }

                if((gclCookie !== "undefined" && gclCookie !== "") && this.ga_client_id === gaCookie) {
                    this.gcl_id = gclCookie
                }

                formData.append('ga_client_id', this.ga_client_id)
                formData.append('gcl_id', this.gcl_id)
                formData.append('insurance_company_id', this.insuranceCompanyId)

                // serialize form data
                $(this.$el)
                    .serializeArray()
                    .forEach(({ name, value }) => {
                        formData.append(name, value)
                    })

                // formData.set('dmp', document.getElementById('dmp').checked ? 1 : 0);

                // confirmation_of_diagnosis files
                if (files.length > 0) {
                    for (let i = 0; i < files.length; i++) {
                        formData.append(`confirmation_of_diagnosis[${i}]`, files[i])
                    }
                }

                axios
                    .post('api/patient-prescription-form', formData, {
                        headers: {
                            'Accept-Language': 'de',
                            'Content-Type': 'multipart/form-data',
                        }
                    })
                    .then((e) => {
                        window.dataLayer.push({
                            'event': 'pre_registration_web',
                            'conversion': 'Prescription submitted'
                        })

                        setTimeout(() => {
                            Vuemit.fire('Button--sending-failed', true)
                            window.location.replace('einreichung-success/'+e.data.data.form_id)
                        }, 500)
                    })
                    .catch((e) => {
                        console.log(e.response)
                        this.errors = e.response.data.errors
                        Vuemit.fire('Button--sending-failed', true)
                        this.scrollToError()
                    })
            },
            fetchCompanies() {
                axios
                    .get('api/de-insurers')
                    .then((e) => {
                        this.insuranceCompanies = e.data.data
                    })
                    .catch((e) => {
                        console.log(e.response)
                    })
            },
            async scrollToError() {
                await this.$nextTick()

                var firstError = document.querySelector('.input-error-border')

                $('html, body').animate(
                    {
                        scrollTop: $(firstError).offset().top - 180
                    },
                    800
                )
            },
            handleFocusOut(event) {
                setTimeout(() => {
                    if(this.searchValue === '' && !event.relatedTarget || (event.relatedTarget && !event.relatedTarget.dataset)) {
                        this.isDropdownVisible = false
                        this.isActive = false
                        this.insuranceCompanyId = ''
                    }
                }, 150);
            },
            selectCompany(name, id) {
                this.$set(this, 'searchValue', name)
                this.isDropdownVisible = false
                this.insuranceCompanyId = id
                this.errors.insurance_company_id = null
            },
            toggleDropdown() {
                this.isActive = true
                this.isDropdownVisible = true
            }
        }
    }
</script>
